<template lang="pug">
.container_typeahead
    .internalContainer
        .selectedItemsContainer(v-if="isMultipleSelect")
            label.selectedItem(v-if='shouldShowItem(item, index)' @click="addOrRemoveList(item)" v-for='(item, index) in selectedItems' :key='item.id') {{getSelectedItemLabel(item, index)}}
        vm-input.input(v-model="inputValue" @focus="inputClick" @click="inputClick" @keydown.down="down" @keydown.up="up" @keypress.enter="enter" @keydown.tab="tab")
        vm-icon.icon(:icon="!isDropdownVisible ? 'arrow-ios-downward-outline' : 'arrow-ios-upward-outline'" @on-icon-click="inputClick")
    .dropdown_container(v-if="isDropdownVisible")
      #scroll.dropdown
          .dropdown_item(v-if="!data.length") Sin datos que mostrar
          .dropdown_item(v-else v-for="(item, index) in data" @click="itemClick(item)" :id="item.id" :style="getDropdownItemStyle(item, index)")
            vm-icon(v-if="isMultipleSelect && isInList(item.id)" icon="checkmark-outline")
            slot(v-if="item.code") {{ item.code + ( showColumn != 'code'  ? " | " + item[showColumn] : "") + ( !hasBranch() && !isSFS && !isProducts ? " | " + (item.branch_display ? item.branch_display : item.branch_name) : "")}}
            slot(v-else) {{ item[showColumn] }}
</template>
<script>
export default {
  name: 'TypeAheadSelect',
  inheritAttrs: false,
  props: {
    autoSearch: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array,
      default: () => []
    },
    debounceMs: {
      type: Number,
      default: 200
    },
    defaultValue: String,
    showColumn: {
      type: String,
      default: () => 'code'
    },
    isMultipleSelect: {
      type: Boolean,
      default: () => false
    },
    selectedItems: {
      type: Array,
      default: () => []
    },
    isSFS: {
      type: Boolean,
      default: () => false
    },
    isProducts: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      isDropdownVisible: false,
      clicksByOutside: 0,
      inputValue: '',
      debounceTimer: null,
      indexFocus: 0,
      presentedItems: 0
    }
  },
  watch: {
    inputValue (newValue) {
      this.resetIndexFocus()
      this.isDropdownVisible = newValue !== this.defaultValue
      this.search(newValue)
    },
    defaultValue (newVal) {
      if (newVal !== undefined) {
        this.inputValue = newVal
      }
    },
    isDropdownVisible (newValue) {
      if (newValue) this.resetIndexFocus()
    }
  },
  created () {
    if (this.defaultValue !== undefined) {
      this.inputValue = this.defaultValue
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    inputClick () {
      this.isDropdownVisible = true
      if (this.autoSearch) {
        this.inputValue ? this.search(this.inputValue) : this.search('')
      }
      this.clicksByOutside = 0
    },
    search (value) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      this.debounceTimer = setTimeout(() => {
        this.$emit('search', value)
      }, this.debounceMs)
    },
    itemClick (item) {
      this.$emit('item-select', item)
      this.addOrRemoveList(item)
      if (!this.isMultipleSelect) {
        setTimeout(() => {
          this.isDropdownVisible = false
        }, 300)
      }
    },
    handleClickOutside () {
      this.clicksByOutside = this.clicksByOutside + 1
      if (this.clicksByOutside > 1 && this.isDropdownVisible) {
        this.isDropdownVisible = false
      }
    },
    tab () {
      this.isDropdownVisible = false
    },
    isSelected (index) {
      return index === this.indexFocus
    },
    isInList (id) {
      const found = this.selectedItems.find(item => item.id === id)
      return found !== undefined
    },
    addOrRemoveList (item) {
      if (this.isMultipleSelect) {
        if (!this.isInList(item.id)) { this.selectedItems.push({ id: item.id, [`${this.showColumn}`]: item[this.showColumn] }) } else { this.selectedItems.splice(this.findIndexInList(item.id), 1) }
      } else this.inputValue = item[this.showColumn]
    },
    scroll (direction, index) {
      const item = this.findItem(index)
      const itemHeight = document.getElementById(item.id).clientHeight
      const scrollStep = itemHeight / 40
      const scroll = document.getElementById('scroll')
      const porcentage = (direction === 'down' ? 0.22 : 0.215) * scrollStep * scroll.clientHeight
      scroll.scrollTop += (direction === 'up' ? -1 : 1) * porcentage
    },
    up () {
      if (this.indexFocus - 1 >= 0) {
        this.indexFocus--
        if (this.indexFocus < this.data.length - 2) this.scroll('up', this.indexFocus + 1)
      }
    },
    down () {
      if (this.indexFocus + 1 < this.data.length) {
        this.indexFocus++
        if (this.indexFocus > 1) this.scroll('down', this.indexFocus - 1)
      }
    },
    enter () {
      this.itemClick(this.findItem(this.indexFocus))
    },
    findItem (id) {
      return this.data.find((item, index) => index === id)
    },
    findIndex (id) {
      var indextr = 0
      this.data.find((item, index) => {
        if (item.id === id) indextr = index
      })
      return indextr
    },
    findIndexInList (id) {
      var indextr = 0
      this.selectedItems.find((item, index) => {
        if (item.id === id) indextr = index
      })
      return indextr
    },
    resetIndexFocus () {
      this.indexFocus = 0
      const scroll = document.getElementById('scroll')
      scroll.scrollTop = 0
    },
    shouldShowItem (item, index) {
      return this.isInList(item.id) && index < 5
    },
    getSelectedItemLabel (item, index) {
      return index === 4 ? '+' + (this.selectedItems.length - 4) : item[this.showColumn]
    },
    getDropdownItemStyle (item, index) {
      return {
        background: this.isInList(item.id) ? 'GREEN' : this.isSelected(index) ? '#a54d35' : 'TRANSPARENT',
        color: this.isSelected(index) || this.isInList(item.id) ? 'WHITE' : 'BLACK',
        border: this.isSelected(index) ? '1px solid BLACK' : '1px solid WHITE'
      }
    },
    hasBranch () {
      return Boolean(this.$auth.user().branch_id)
    }
  }
}
</script>
<style lang="scss" scoped>
.container_typeahead {
    position: relative;
    width: 100%;
}
.icon {
  position: absolute;
  cursor: pointer;
  bottom: 0.7rem;
  right: 0.5rem;
}
.dropdown_container {
    margin-top: 0.1rem;
    z-index: 1000;
    position: absolute;
    height: auto;
    width: 100%;
    background-color: white;
}
.dropdown {
    box-shadow: 0.3em 0.3em 1em rgba(99, 99, 99, 0.3);
    max-height: 10rem;
    width: 100%;
    border: solid 1px rgb(221, 221, 221);
    border-radius: 0.6rem;
    background-color: white;
    padding: 0.3rem 0 0.3rem 0.3rem;
    overflow: scroll;
}
.dropdown_item {
    cursor: pointer;
    font-size: 1rem;
    padding: 0.25rem 0 0.25rem 0.5rem;
    border-radius: 0.3rem;
}
.dropdown_item:hover {
    background-color: #a54d35;
    color: white;
}
.selectedItem {
    border-radius: 30px;
    border: 1px solid;
    padding: 7px;
    font-size: 0.7rem;

    transition: 0.3s;
}
.selectedItem:hover {
    background-color: GREEN;
}
.selectedItemsContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 0.5rem;
}
</style>
